

export const GetCities = async cityCode => {

    const res = await fetch(`https://booking.sila-avia.ru/websky/json/dependence-cities?isBooking=true&returnPoints=destination&type=json&cityCode=${cityCode}`, {
        method: 'GET',
    });

    return res.json();

}